<template lang="pug">
#modal-user-remove
    //- Button
    button.btn.btn-sm.btn-secondary(@click="showModal = true", :disabled="user.role === 'owner'")
        font-awesome-icon.mr-2(icon="trash")
        | Benutzer löschen

    //- Modal
    .modal-backdrop.fade.show(v-if="showModal")
    .modal.fade.show(:class="{ 'd-block': showModal }")
        .modal-dialog.modal-dialog-scrollable.modal-md: .modal-content
            header.modal-header
                h5.modal-title Benutzer wirklich löschen?
                button.close(type="button", @click="showModal = false") &times;
            .modal-body
                p Möchten Sie den Benutzer {{ user.username }} wirklich löschen?
            footer.modal-footer
                button.btn.btn-secondary(type="button", @click="showModal = false") Abbrechen
                button.btn.btn-primary(type="button", @click="removeAndClose") Löschen
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { userService } from '@/services'

library.add(faTrash)

export default {
    props: {
        user: {
            type: Object,
            default () {},
            validator (value) {
                return value.username && value.id
            }
        }
    },
    data () {
        return {
            showModal: false
        }
    },
    methods: {
        async removeAndClose () {
            try {
                await userService.remove(this.user.id)
                this.showModal = false
                this.$store.dispatch('alert/success', 'Benutzer gelöscht')
                // trigger parent loadUsers to refresh userlist - this is exactly, where vuex comes in handy - TODO: implement via store
                this.$emit('removed')
            } catch (err) {
                this.$store.dispatch('alert/error', 'Benutzer konnten nicht gelöscht werden (' + err.message + ')')
            }
        }
    }
}
</script>
